import { useCallback } from 'react';
import { isBrowser } from '../utils/isBrowser';

interface useDataLayerPushReturn {
  dataLayerPush: (data: object) => void;
}

export const useDataLayerPush = (): useDataLayerPushReturn => {
  const dataLayerPush = useCallback((data: object) => {
    if (isBrowser) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ...data,
      });
    }
  }, []);

  return {
    dataLayerPush,
  };
};
